const Endpoints = {
  feed_types: '/feedback/crud/feedback_type/',
  event_type: '/feedback/crud/event_type/',

  feed: '/feedback/crud/feedback/',
  enquiry: '/feedback/crud/enquiry/',
};

export default Endpoints;
